import React from "react";
import { Link } from "react-router-dom";
import { useGlobalContext } from "./context/AuthContext";
import Profile from "./auth/Profile";

const Navbar: React.FC = () => {
  const { user } = useGlobalContext();

  return (
    <nav className="site-navbar">
      <Link to="/" className="site-navbar-brand">
        <span className="site-navbar-brand-dot" />
        <span>Gistoscope</span>
      </Link>

      <div className="site-navbar-links">
        <Link to="/home" className="site-navbar-link">
          Home
        </Link>
        <Link to="/" className="site-navbar-link">
          Subjects
        </Link>
      </div>

      <div className="site-navbar-user">
        {user ? (
          <div className="site-navbar-user-copy">
            <span className="site-navbar-welcome">
              Welcome, <span className="site-navbar-user-name">{user.name}</span>
              {user.userType === "admin" && <span className="site-navbar-admin-badge">Admin</span>}
            </span>
            <Profile />
          </div>
        ) : (
          <Link to="/login" className="site-navbar-login">
            Login
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
